import { CompanyWidgetId, CompanyWidgetsOrderConfig, RISK_TAB_WIDGET_ID } from '../Company.constants';

export const RISK_WIDGETS_KEY = 'RiskWidgets';

export const LEFT_CONTAINER_WIDGETS: CompanyWidgetId[] = [
  RISK_TAB_WIDGET_ID.COMPANY_OVERVIEW,
  RISK_TAB_WIDGET_ID.FUNDAMENTALS,
];

export const MIDDLE_CONTAINER_WIDGETS: CompanyWidgetId[] = [
  RISK_TAB_WIDGET_ID.CQS_SUMMARY,
  RISK_TAB_WIDGET_ID.CRE_SUMMARY,
  RISK_TAB_WIDGET_ID.RISK_PRODUCT,
];
export const RIGHT_CONTAINER_WIDGETS: CompanyWidgetId[] = [RISK_TAB_WIDGET_ID.RISK_OVERVIEW];

export const DEFAULT_WIDGETS_ORDER_CONFIG: CompanyWidgetsOrderConfig = {
  leftSideWidgets: LEFT_CONTAINER_WIDGETS,
  middleWidgets: MIDDLE_CONTAINER_WIDGETS,
  rightSideWidgets: RIGHT_CONTAINER_WIDGETS,
};
